import HowToApply from '@components/pages/resources';

export default HowToApply;
